import { YOUR_LOAN_OPTIONS } from 'constants/paths';
import {
  EXISTING_ACCOUNT_RADIO_NO_OPTION,
  EXISTING_ACCOUNT_RADIO_YES_OPTION,
  SOLE_TYPE
} from 'constants/general';
import { navigateToScreen, navigateToLoginRegistration } from 'actionCreators/navigation';

function submitHomeScreen(values) {
  /**
   * FYI We don't need to submit data to the server from the Home Screen.
   * However, we can still apply most of the redux-form lifecycle for consistency.
   */
  return new Promise((resolve) => {
    // do any additional work after we submit the form here...

    // If we've got this far, no errors occurred while submitting.
    // Therefore, we can resolve() the Promise successfully.
    resolve();
  });
}

function submitHomeScreenSuccess(result, dispatch, props) {
  switch (props.accountValue) {
    // navigate to the next step of the sole journey
    // in this case, if you have a yes or no value, we'll take you to the same place
    case EXISTING_ACCOUNT_RADIO_YES_OPTION:
      dispatch(navigateToLoginRegistration(SOLE_TYPE));
      break;
    case EXISTING_ACCOUNT_RADIO_NO_OPTION: {
      dispatch(navigateToScreen(YOUR_LOAN_OPTIONS));
      break;
    }
    default: {
      break;
    }
  }
}

function submitHomeScreenFail(result, dispatch, props) {}

export {
  submitHomeScreen as onSubmit,
  submitHomeScreenSuccess as onSubmitSuccess,
  submitHomeScreenFail as onSubmitFail
};
